export const ACTION = {
    GOAL_MARKETING:'GOAL_MARKETING',
    GOAL_VIDEO_PODCAST_BLOG: 'GOAL_VIDEO_PODCAST_BLOG',
};


